import React from "react";
import "../../Scheduler/components/SchedulerFilters/SchedulerFilters.scss";

function StatusCheckFitler({  selectedStatus, setStatusFilter, appointmentStatusList}) {
    
    const handleChange = (e, item) => {
        const status = [...selectedStatus];
        const staffIndex = status?.findIndex((v) => +item.id === +v);
        if (e.target.checked) {
            status.push(item.id);
        } else {
            if (staffIndex > -1) status.splice(staffIndex, 1);
        }
        setStatusFilter(status);
    };

    return (
        <ul className={["filter-list"]}>
            {appointmentStatusList?.map((item, key) => (
                    <li key={key}>
                        <div className="ch-checkbox">
                            <label>
                                <input
                                    type="checkbox"
                                    onChange={(e) => handleChange(e, item)}
                                    checked={selectedStatus?.includes(item.id)}
                                />{" "}
                                <span> {item.title}</span>
                            </label>
                        </div>
                    </li>
                ))}
        </ul>
    );
}

export default StatusCheckFitler;
